(function () {
  const FORM_SELECTOR = '[data-qbs-search-suggestions]';
  const INPUT_SELECTOR = '[data-qbs-search-suggestions-input]';
  const PANEL_SELECTOR = '[data-qbs-search-suggestions-panel]';
  const LIST_SELECTOR = '[data-qbs-search-suggestions-list]';
  const VIEW_ALL_SELECTOR = '[data-qbs-search-suggestions-view-all]';
  const initializedForms = new WeakSet();

  function debounce(callback, delay) {
    let timeoutId;

    return function (...args) {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => callback.apply(this, args), delay);
    };
  }

  function clearElement(element) {
    while (element.firstChild) {
      element.firstChild.remove();
    }
  }

  function getProductImage(product) {
    const image = product.featured_image || product.image;

    if (!image) return '';
    if (typeof image === 'string') return image;

    return image.url || image.src || '';
  }

  function formatPrice(value, currencyCode) {
    if (value === undefined || value === null || value === '') return '';
    if (typeof value === 'string' && /[^\d.,\s]/.test(value)) return value;

    const numberValue = Number(String(value).replace(',', '.'));
    if (!Number.isFinite(numberValue)) return String(value);

    const amount = Number.isInteger(numberValue) && numberValue > 99 ? numberValue / 100 : numberValue;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'EUR',
      }).format(amount);
    } catch (error) {
      return String(value);
    }
  }

  function getProductPrice(product, currencyCode) {
    return formatPrice(product.price || product.price_min || product.min_price, currencyCode);
  }

  function createProductItem(product, currencyCode) {
    const link = document.createElement('a');
    link.className = 'form-search__suggestions-item';
    link.href = product.url || '#';

    const media = document.createElement('span');
    media.className = 'form-search__suggestions-image';

    const imageUrl = getProductImage(product);
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = product.title || '';
      image.loading = 'lazy';
      image.width = 42;
      image.height = 42;
      media.append(image);
    }

    const title = document.createElement('span');
    title.className = 'form-search__suggestions-title';
    title.textContent = product.title || '';

    const price = document.createElement('span');
    price.className = 'form-search__suggestions-price';
    price.textContent = getProductPrice(product, currencyCode);

    link.append(media, title, price);

    return link;
  }

  function updateViewAllUrl(link, searchUrl, query) {
    const url = new URL(searchUrl, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    link.href = url.toString();
  }

  function initSearchSuggestions(form) {
    if (initializedForms.has(form)) return;

    const input = form.querySelector(INPUT_SELECTOR);
    const panel = form.querySelector(PANEL_SELECTOR);
    const list = form.querySelector(LIST_SELECTOR);
    const viewAll = form.querySelector(VIEW_ALL_SELECTOR);

    if (!input || !panel || !list || !viewAll) return;

    initializedForms.add(form);

    let abortController;

    function hidePanel() {
      if (abortController) abortController.abort();
      clearElement(list);
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function showProducts(products, query) {
      clearElement(list);

      if (!products.length) {
        hidePanel();
        return;
      }

      products.forEach((product) => {
        list.append(createProductItem(product, form.dataset.currencyCode));
      });

      updateViewAllUrl(viewAll, form.dataset.searchUrl || form.action, query);
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    const fetchSuggestions = debounce(async function () {
      const query = input.value.trim();

      if (!query) {
        hidePanel();
        return;
      }

      if (abortController) abortController.abort();
      abortController = new AbortController();

      const url = new URL(form.dataset.predictiveUrl, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', form.dataset.suggestionLimit || '3');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');

      try {
        const response = await fetch(url.toString(), {
          signal: abortController.signal,
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) {
          hidePanel();
          return;
        }

        const suggestions = await response.json();
        const products = suggestions?.resources?.results?.products || [];

        if (input.value.trim() !== query) return;

        showProducts(products, query);
      } catch (error) {
        if (error.name !== 'AbortError') hidePanel();
      }
    }, 200);

    input.addEventListener('input', fetchSuggestions);
    input.addEventListener('focus', function () {
      if (input.value.trim()) fetchSuggestions();
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hidePanel();
    });
    form.addEventListener('reset', hidePanel);
  }

  function initAllSearchSuggestions() {
    document.querySelectorAll(FORM_SELECTOR).forEach(initSearchSuggestions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSearchSuggestions);
  } else {
    initAllSearchSuggestions();
  }

  document.addEventListener('shopify:section:load', initAllSearchSuggestions);
})();
